import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import UsersTab from '../components/userManagement/UsersTab';
import BooksTab from '../components/userManagement/BooksTab';
import GroupsTab from '../components/userManagement/GroupsTab';
import TabularPage from '../components/tabs/TabularPage';
import useUserPermissions from 'hooks/useUserPermissions';
import { USER_MANAGEMENT_ROUTES } from 'constants/routes';

export const userManagementTabs = [
    {
        name: <FormattedMessage id="user_management_users" />,
        relativePath: USER_MANAGEMENT_ROUTES.USER,
        component: <UsersTab />,
    },
    {
        name: <FormattedMessage id="user_management_groups" />,
        relativePath: USER_MANAGEMENT_ROUTES.GROUPS,
        component: <GroupsTab />,
    },
    {
        name: <FormattedMessage id="user_management_books" />,
        relativePath: USER_MANAGEMENT_ROUTES.BOOKS,
        component: <BooksTab />,
    },
];

const UserManagementPage = () => {
    const { isInternalAdmin } = useUserPermissions();

    const routes = useMemo(() => {
        if (!isInternalAdmin) {
            return userManagementTabs.filter((x) => x.relativePath !== USER_MANAGEMENT_ROUTES.GROUPS);
        }
        return userManagementTabs;
    }, [isInternalAdmin]);

    return <TabularPage routes={routes} />;
};

export default UserManagementPage;
